import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { SELLERS_BASE_URL } from '../../api/Custom'
import { getToken } from '../../custome/action'

export const warehouseApi = createApi({
    reducerPath: 'warehouseApi',
    baseQuery: fetchBaseQuery({ baseUrl: SELLERS_BASE_URL }),
    tagTypes : ['warehouse'],
    endpoints: (builder) => ({
        getAllWarehouses: builder.query({
            query: (state) => ({
                url: `/getAllWarehouse?pageNumber=${state?.page - 1}&limit=${state?.limit}`,
                method: 'GET',
                headers:  {
                    'Authorization': 'Bearer ' + getToken(),
                    'Content-Type': 'application/json'
                }
            }),
            providesTags : ['warehouse']
        }),
        saveWarehouse : builder.mutation({
            query : (data)=> ({
                url: `/saveWarehouseRecord`,
                method: 'POST',
                body:data,
                headers:  {
                    'Authorization': 'Bearer ' + getToken(),
                    'Content-Type': 'application/json'
                }
            }),
            invalidatesTags:['warehouse']
        }),
        updateWarehouse : builder.mutation({
            query : (data) =>({
                url: `/updateWarehouseRecord`,
                method: 'POST',
                body:data,
                headers:  {
                    'Authorization': 'Bearer ' + getToken(),
                    'Content-Type': 'application/json'
                }
            }),
            invalidatesTags:['warehouse']
        })
       
    })
})

export const { useGetAllWarehousesQuery , useSaveWarehouseMutation,useUpdateWarehouseMutation} = warehouseApi